import ShoppingBag from '../src/ShoppingBag';
export default ShoppingBag;
